import { PrecedingSpaces } from '../model/precedingSpaces';
export class AdminPrecedingSpacesBuilder {
    static buildPrecedingSpaces(data) {
        const adminPrecedingSpaces = new PrecedingSpaces();
        adminPrecedingSpaces.id_reservation = data.id_reservation;
        adminPrecedingSpaces.plate = data.plate;
        adminPrecedingSpaces.space_number = data.space_number;
        adminPrecedingSpaces.calle = data.calle;
        return adminPrecedingSpaces;
    }
}
//# sourceMappingURL=adminPrecedingSpaces-builder.js.map